// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"763adf4d","198":"ddd9a3d2","433":"a300283d","445":"92023dab","554":"cefc8a88","618":"77faa37a","908":"7eb08a21","988":"96196a81","996":"15717b72"}[chunkId] + ".chunk.css";
};